import React, { useEffect, useRef, useState } from "react";
import {
  GeneralContainer,
  Header,
  MoodMeterLogo,
  MoodMeterText,
  UsersContainer,
  TimeContainer,
  ButtonsContainer,
  CancelSettings,
  ContentSelect,
  SelectStyles,
  SendSettings,
  ContentModalAdd,
  TextModalAdd,
  ButtonAdd,
  ButtonAddCancel,
} from "./MoodMeterSettings.styled";
import BackButtonComponent from "../../BackButtonComponent/BackButtonComponent";
import { useHistory } from "react-router-dom";
import Checkbox from "@mui/material/Checkbox";
import CropLandscapeIcon from "@material-ui/icons/CropLandscape";
import { IconGuest } from "../../SurveyConfigurationForm/SurveyConfiguration.styled";
import { Col, Form, Row } from "react-bootstrap";
import Select1 from "react-select";
import guestIcon from "../../../assets/svg/icon-guest.svg";
import { IconButton, List } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteForeverRoundedIcon from "@material-ui/icons/DeleteForeverRounded";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  ALL_DETAILS_BY_REASON_ID,
  ALL_REASONS,
  ALL_WELLNESS_MAIL_BY_CITY,
  ALL_WELLNESS_MAIL_CATCH_ALL,
  COUNTRIES_BY_CLIENT,
  USERS_BY_IDS,
  USERS_IN_ROLE2,
  SMILEYS,
  MOOD_METER_GET_CONFIGURATION,
} from "../../../GraphQL/Queries";
import {
  CHANGE_STATE_REASON,
  CHANGE_STATE_REASON_DETAIL,
  CREATE_MULTIPLE_WELLNESS_MAIL,
  CREATE_MULTIPLE_WELLNESS_MAIL_CATCH_ALL,
  CREATE_REASON,
  CREATE_REASON_DETAIL,
  DELETE_MULTIPLE_WELLNESS_MAIL,
  DELETE_MULTIPLE_WELLNESS_MAIL_CATCH_ALL,
  MOOD_METER_UPDATE_CONFIGURATION,
  MOOD_METER_UPDATE_CONFIGURATION_QUESTION,
} from "../../../GraphQL/Mutations";
import { NotificationManager } from "react-notifications";
import {
  getStateLogin,
  getStateLoginComplete,
} from "../../../containers/LayoutHome/stateLogin";
import { TextField } from "@mui/material";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { ReactComponent as MoodMeterSettingsIcon } from "../../../assets/svg/moodmeter-settings-icon.svg";
import PortalModal from "../../../Portals";
import ModalLoader from "../../ModalLoader/ModalLoader";
import { ROLES } from "../../../util/RolesConstants";

const intervalOptions = [
  { value: 1, label: 1 },
  { value: 2, label: 2 },
  { value: 3, label: 3 },
  { value: 4, label: 4 },
  { value: 5, label: 5 },
  { value: 6, label: 6 },
  { value: 7, label: 7 },
  { value: 8, label: 8 },
  { value: 9, label: 9 },
  { value: 10, label: 10 },
  { value: 11, label: 11 },
  { value: 12, label: 12 },
  { value: 13, label: 13 },
  { value: 14, label: 14 },
  { value: 15, label: 15 },
  { value: 16, label: 16 },
  { value: 17, label: 17 },
  { value: 18, label: 18 },
  { value: 19, label: 19 },
  { value: 20, label: 20 },
  { value: 21, label: 21 },
  { value: 22, label: 22 },
  { value: 23, label: 23 },
  { value: 24, label: 24 },
];

const occurrenceOptions = [
  { value: 1, label: 1 },
  { value: 2, label: 2 },
  { value: 3, label: 3 },
  { value: 4, label: 4 },
  { value: 5, label: 5 },
  { value: 6, label: 6 },
];

const MoodMeterSettings = () => {
  const history = useHistory();
  const [user] = useState(getStateLoginComplete());
  const [clientId] = useState(user.clientId);
  const [guestsData, setGuestsData] = useState();
  const rSelectedUsers = useRef();
  const rSelectedCountries = useRef();
  const rselectedInterval = useRef();
  const rselectedOccurrence = useRef();
  const [countriesData, setCountriesData] = useState([]);
  const rSelectedCity = useRef();
  const [cityData, setCityData] = useState();
  const [renderAgain, setrenderAgain] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedGuests, setSelectedGuests] = useState([]);
  const [savedGuests, setSavedGuests] = useState([]);
  const [inactivityInterval, setInactiveInterval] = useState(0);
  const [ocurrencesPerDay, setOcurrencesPerDay] = useState(0);
  const [reasonsActived, setReasonsActived] = useState([]);
  const [newReasonsActived, setNewReasonsActived] = useState([]);
  const [newReasons, setNewReasons] = useState([]);
  const [reasons, setReasons] = useState([]);
  const [details, setDetails] = useState([]);
  const [detailsActived, setDetailsActived] = useState([]);
  const [newDetails, setNewDetails] = useState([]);
  const [newDetailsActived, setNewDetailsActived] = useState([]);
  const [moodMeterUpdateConfig] = useMutation(MOOD_METER_UPDATE_CONFIGURATION);
  const [moodMeterUpdateConfigQuestion] = useMutation(
    MOOD_METER_UPDATE_CONFIGURATION_QUESTION
  );
  const [openReasonModal, setOpenReasonModal] = useState(false);
  const [addReason, setAddReason] = useState("");
  const [openDetailModal, setOpenDetailModal] = useState(false);
  const [addDetail, setAddDetail] = useState("");
  const [newQuestion, setNewQuestion] = useState();
  const [reasonSelectedForDetail, setReasonSelectedForDetail] = useState();
  const [activeCatchAll, setActiveCatchAll] = useState(false);
  const [countrySelected, setCountrySelected] = useState();
  const [citySelected, setCitySelected] = useState();
  const [createMultipleWellnessMail] = useMutation(
    CREATE_MULTIPLE_WELLNESS_MAIL
  );
  const [deleteMultipleWellnessMail] = useMutation(
    DELETE_MULTIPLE_WELLNESS_MAIL
  );
  const [createMultipleWellnessMailCatchAll] = useMutation(
    CREATE_MULTIPLE_WELLNESS_MAIL_CATCH_ALL
  );
  const [deleteMultipleWellnessMailCatchAll] = useMutation(
    DELETE_MULTIPLE_WELLNESS_MAIL_CATCH_ALL
  );
  const [createReason] = useMutation(CREATE_REASON);
  const [changeStateReason] = useMutation(CHANGE_STATE_REASON);
  const [createReasonDetail] = useMutation(CREATE_REASON_DETAIL);
  const [changeStateReasonDetail] = useMutation(CHANGE_STATE_REASON_DETAIL);

  const [smileySelect, setSmileySelect] = useState(0);
  const [faces, setFaces] = useState([]);

  const [sendSmileys, setSendSmileys] = useState(false);
  const [sendUsers, setSendUsers] = useState(false);
  const [sendReasonDetails, setSendReasonDetails] = useState(false);
  const [timeConfig, setTimeConfig] = useState();
  const [runQueryGetTimeConfig] = useLazyQuery(MOOD_METER_GET_CONFIGURATION, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (!data.moodMeterGetConfiguration.withError) {
        setTimeConfig(data.moodMeterGetConfiguration.outputData);
      } else {
        NotificationManager.error(
          data.moodMeterGetConfiguration.message,
          "",
          5000
        );
      }
    },
  });

  const [runQuerySmileys, { loading: loadingSmileys }] = useLazyQuery(SMILEYS, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (!data.smileys.withError) {
        setFaces([...data.smileys.outputData]);
      } else {
        NotificationManager.error(data.smileys.message, "", 5000);
      }
    },
  });

  const [runQueryCountry] = useLazyQuery(COUNTRIES_BY_CLIENT, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfAllCountries = data.countryLocationList.map((element) => {
        return {
          ...element,
          value: element?.countryId,
          label: element?.countryName,
        };
      });
      setCountriesData(resultOfAllCountries);
    },
  });

  const [runQueryReasons] = useLazyQuery(ALL_REASONS, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (!data.allReasons.withError) {
        let resultOfAllReasons = data.allReasons.outputData.map((element) => {
          return {
            value: element?.id,
            label: element?.description,
            recordState: element?.recordState,
          };
        });
        let reasons = resultOfAllReasons.filter(
          (reasons) => reasons.recordState === "Active"
        );
        let newReasons = resultOfAllReasons.filter(
          (newReasons) => newReasons.recordState === "Inactive"
        );
        setReasons(reasons);
        setNewReasons(newReasons);
      } else {
        NotificationManager.error(data.allReasons.message, "", 5000);
      }
    },
  });

  const [runQueryAllDetailsByReasonId] = useLazyQuery(
    ALL_DETAILS_BY_REASON_ID,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (!data.allDetailsByReasonId.withError) {
          let newdetails = data.allDetailsByReasonId.outputData.filter(
            (newdetail) => newdetail.recordState === "Inactive"
          );
          let details = data.allDetailsByReasonId.outputData.filter(
            (detail) => detail.recordState === "Active"
          );
          setNewDetails(newdetails);
          setDetails(details);
        } else {
          NotificationManager.error(
            data.allDetailsByReasonId.message,
            "",
            5000
          );
        }
      },
    }
  );

  const [runQueryAllWellnessMailByCity] = useLazyQuery(
    ALL_WELLNESS_MAIL_BY_CITY,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let selectUsers = data.allWellnessMailByCity.outputData.map(
          (element) => {
            return {
              label: element.idUser,
              value: element.idUser,
              idWellnessMail: element.idWellnessMail,
              recordState: element.recordState,
              createDate: element.createDate,
              createUser: element.createUser,
            };
          }
        );
        setSelectedUsers(selectUsers);
      },
    }
  );

  const [runQueryAllWellnessMailCatchAll] = useLazyQuery(
    ALL_WELLNESS_MAIL_CATCH_ALL,
    {
      fetchPolicy: "network-only",
      nextFetchPolicy: "cache-and-network",
      onCompleted: (data) => {
        let selectUsers = data.allWellnessMailCatchAll.outputData.map(
          (element) => {
            return {
              label: element.idUser,
              value: element.idUser,
              idWellnessMail: element.idWellnessMail,
              recordState: element.recordState,
              createDate: element.createDate,
              createUser: element.createUser,
            };
          }
        );
        setSelectedUsers(selectUsers);
      },
    }
  );

  const [runQueryUsersInRole2, { error, loading }] = useLazyQuery(
    USERS_IN_ROLE2,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let usersInRole2 = data.userListAdvancedSearch.map((element) => {
          return {
            value: element?.userId,
            label: element?.userFirstName + " " + element?.userLastName,
            firstName: element?.userFirstName,
            lastName: element?.userLastName,
            emailAddress: element?.userTpId,
            ccmsid: element?.userCcms,
            ccmsuser: element?.userCcms,
          };
        });
        setGuestsData(usersInRole2);
      },
    }
  );

  const [runQueryUsersByIds] = useLazyQuery(USERS_BY_IDS, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let usersByIds = data.userAdminlistByIds.map((element) => {
        return {
          value: element?.userId,
          label: element?.userFullName,
          firstName: element?.userFirstName,
          lastName: element?.userLastName,
          emailAddress: element?.userTpId,
          ccmsuser: element?.userCcms,
          ccmsid: element?.userCcms,
          userStatus: element?.enabled,
        };
      });
      setSavedGuests(usersByIds);
      setSelectedGuests(usersByIds);
    },
  });

  useEffect(() => {
    runQueryUsersInRole2({
      variables: {
        rolesId: [ROLES.COUNTRY_ADMIN, ROLES.WELLNESS_PROFESSIONAL, ROLES.GAM],
      },
      context: { clientName: "LinkUsers" },
    });
    if (clientId) {
      runQueryCountry({
        variables: { clientId: clientId },
        context: { clientName: "LinkUsers" },
      });
    }
    //runQueryReasons();
  }, []);

  useEffect(() => {
    if (citySelected && !activeCatchAll) {
      runQueryAllWellnessMailByCity({
        variables: {
          idCity: citySelected?.value,
        },
      });
    } else {
      if (activeCatchAll) {
        runQueryAllWellnessMailCatchAll();
      }
    }
  }, [activeCatchAll, citySelected]);

  useEffect(() => {
    if (timeConfig?.intervalDuration || timeConfig?.recordsPerDay) {
      setInactiveInterval(timeConfig?.intervalDuration);
      setOcurrencesPerDay(timeConfig?.recordsPerDay);
    }
  }, [timeConfig]);

  useEffect(() => {
    if (selectedUsers.length > 0) {
      let selected = selectedUsers.map((element) => {
        return element.value;
      });
      runQueryUsersByIds({
        variables: { usersIds: [...selected] },
        context: { clientName: "LinkUsers" },
      });
    } else {
      setSelectedGuests([]);
    }
  }, [selectedUsers]);

  useEffect(() => {
    if (renderAgain) {
      runQueryReasons();
      if (reasonSelectedForDetail) {
        runQueryAllDetailsByReasonId({
          variables: {
            reasonId: reasonSelectedForDetail,
          },
        });
      }
      setrenderAgain(!renderAgain);
    }
  }, [renderAgain]);

  let handleChangeMultipleNewReasons = (event) => {
    const { options } = event.target;
    const value = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }

    setNewReasonsActived(value);
  };

  let handleChangeMultipleReasons = (event) => {
    const { options } = event.target;
    const value = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }

    setReasonsActived(value);
  };

  let handleChangeMultipleNewDetails = (event) => {
    const { options } = event.target;
    const value = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }

    setNewDetailsActived(value);
  };

  let handleChangeMultipleDetails = (event) => {
    const { options } = event.target;
    const value = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }

    setDetailsActived(value);
  };

  let handleChangeSelectUsers = (items) => {
    if (items.length > 0) {
      let selection = JSON.parse(JSON.stringify(savedGuests));
      items.map((element) => {
        if (selection.findIndex((f) => f.value === element.value) === -1) {
          selection.push(element);
        }
      });
      setSelectedGuests(selection);
      setrenderAgain(!renderAgain);
    } else {
      setSelectedGuests(savedGuests);
    }
  };

  let handleChangeSelectCountries = (item) => {
    if (item) {
      if (
        countrySelected?.value === undefined ||
        item.value !== countrySelected?.value
      ) {
        setCountrySelected(item);
        setCitySelected("");
        rSelectedCity.current.clearValue();
        getCityForCountry(item.value);
      }
    }
  };

  const getCityForCountry = (id) => {
    let selectedCountry = countriesData.filter(
      (e) => e.countryId === parseInt(id)
    );
    if (selectedCountry?.length > 0) {
      let citiesArr = selectedCountry[0].cities.map((e) => {
        return {
          ...e,
          value: e.cityId,
          label: e.cityName,
        };
      });
      setCityData(citiesArr);
    } else {
      setCityData([]);
    }
  };

  let handleChangeSelectCity = (item) => {
    if (item) {
      setCitySelected(item);
      setrenderAgain(!renderAgain);
    }
  };

  let handleChangeSelectReason = (item) => {
    setReasonSelectedForDetail(item.value);
    if (item.value) {
      runQueryAllDetailsByReasonId({
        variables: {
          reasonId: item.value,
        },
      });
    } else {
      setDetails([]);
      setNewDetails([]);
    }
  };

  let removeUser = (index, label) => {
    if (!activeCatchAll) {
      if (citySelected) {
        deleteMultipleWellnessMail({
          variables: {
            idUsers: [selectedGuests[index].value],
            deleteUser: getStateLogin(),
            idCity: citySelected?.value,
          },
        })
          .then((response) => {
            if (response.data.deleteMultipleWellnessMail) {
              if (rSelectedUsers.current.state.selectValue) {
                let objremove = rSelectedUsers.current.state.selectValue.filter(
                  (f) => f.value === selectedGuests[index].value
                );
                if (objremove.length)
                  rSelectedUsers.current?.removeValue(objremove[0]);
              }
              let dso = savedGuests;
              dso.splice(index, 1);
              setSelectedGuests(dso);
              setSavedGuests(dso);
              setrenderAgain(!renderAgain);
              NotificationManager.success(
                "The user has been removed",
                "",
                5000
              );
            }
          })
          .catch((error) => {
            const errorMessage = error.message.split("\n")[0];
            NotificationManager.error(errorMessage, "", 5000);
          });
      } else {
        NotificationManager.warning(
          "You need to select a city before delete users of mood meter config",
          "",
          5000
        );
      }
    } else {
      deleteMultipleWellnessMailCatchAll({
        variables: {
          idUsers: [selectedGuests[index].value],
          deleteUser: getStateLogin(),
        },
      })
        .then((response) => {
          if (response.data.deleteMultipleWellnessMailCatchAll) {
            if (rSelectedUsers.current.state.selectValue) {
              let objremove = rSelectedUsers.current.state.selectValue.filter(
                (f) => f.value === selectedGuests[index].value
              );
              if (objremove.length)
                rSelectedUsers.current?.removeValue(objremove[0]);
            }
            let dso = savedGuests;
            dso.splice(index, 1);
            setSelectedGuests(dso);
            setSavedGuests(dso);
            setrenderAgain(!renderAgain);
            NotificationManager.success("The user has been removed", "", 5000);
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  };

  let saveSmileysConfig = () => {
    NotificationManager.success(
      "The smiley of mood meter config has been updated",
      "",
      3000
    );
  };

  let saveUsers = () => {
    if (!activeCatchAll) {
      let selectionForCreate = selectedGuests.map((item) => {
        return item.value;
      });
      if (citySelected) {
        createMultipleWellnessMail({
          variables: {
            idUsers: [...selectionForCreate],
            createUser: getStateLogin(),
            idCity: citySelected?.value,
          },
        })
          .then((response) => {
            let err = response.withError;
            if (!err) {
              NotificationManager.success(
                "The users of mood meter config has been updated",
                "",
                3000
              );
              setCountrySelected("");
              setCitySelected("");
            }
          })
          .catch((error) => {
            const errorMessage = error.message.split("\n")[0];
            NotificationManager.error(errorMessage, "", 5000);
          });
      } else {
        NotificationManager.warning(
          "You need to select a city before add new users of mood meter config",
          "",
          3000
        );
      }
    } else {
      let selectionForCreate = selectedGuests.map((item) => {
        return item.value;
      });
      createMultipleWellnessMailCatchAll({
        variables: {
          idUsers: [...selectionForCreate],
          createUser: getStateLogin(),
        },
      })
        .then((response) => {
          let err = response.withError;
          if (!err) {
            NotificationManager.success(
              "The users of mood meter config has been updated",
              "",
              3000
            );
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  };

  let handleCatchAllEvents = (event) => {
    setCountrySelected("");
    setCitySelected("");
    setSelectedGuests([]);
    rSelectedCity?.current?.clearValue();
    rSelectedCountries?.current?.clearValue();
    rSelectedUsers?.current?.clearValue();
    setActiveCatchAll(event.target.checked);
  };

  let saveTime = () => {
    if (inactivityInterval && ocurrencesPerDay) {
      moodMeterUpdateConfig({
        variables: {
          intervalDuration: parseInt(inactivityInterval),
          recordsPerDay: parseInt(ocurrencesPerDay),
        },
      })
        .then((response) => {
          let err = response.withError;
          if (!err) {
            NotificationManager.success(
              "The time of mood meter config has been updated",
              "",
              3000
            );
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  };

  let handleNewQuestion = (event) => {
    setNewQuestion(event.target.value);
  };

  let saveQuestion = () => {
    moodMeterUpdateConfigQuestion({
      variables: {
        questionForUser: newQuestion,
      },
    })
      .then((response) => {
        let err = response.withError;
        if (!err) {
          NotificationManager.success(
            "The question of mood meter config has been updated",
            "",
            3000
          );
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  let saveReason = () => {
    if (!openReasonModal) {
      return;
    }
    if (!addReason) {
      return NotificationManager.warning(
        "Name of the reason should not be empty",
        "",
        5000
      );
    }
    createReason({
      variables: {
        reasonDescription: addReason,
        userCreateReason: getStateLogin(),
      },
    })
      .then((response) => {
        let err = response.withError;
        if (!err) {
          NotificationManager.success(
            "The reason of mood meter config has been created",
            "",
            5000
          );
          setOpenReasonModal(false);
          setrenderAgain(!renderAgain);
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  let saveDetail = () => {
    if (!openDetailModal) {
      return;
    }
    if (!addDetail) {
      return NotificationManager.warning(
        "Name of the detail should not be empty",
        "",
        5000
      );
    }
    createReasonDetail({
      variables: {
        reasonId: reasonSelectedForDetail,
        reasonDetailDescription: addDetail,
        userCreateReasonDetail: getStateLogin(),
      },
    })
      .then((response) => {
        let err = response.withError;
        if (!err) {
          NotificationManager.success(
            "The reason detail of mood meter config has been created",
            "",
            5000
          );
          setOpenDetailModal(false);
          setrenderAgain(!renderAgain);
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  let deleteReason = () => {
    let newState = `${"DELETED"}`;

    if (newReasonsActived[0]) {
      changeStateReason({
        variables: {
          idReason: parseInt(newReasonsActived[0]),
          newState: newState,
          userChangeState: getStateLogin(),
        },
      })
        .then((response) => {
          let err = response.withError;
          if (!err) {
            let dto = newReasonsActived;
            dto.splice(0, 1);
            setNewReasonsActived(dto);
            NotificationManager.success(
              "The reason of mood meter config has been deleted",
              "",
              5000
            );
            setrenderAgain(!renderAgain);
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else {
      if (reasonsActived[0]) {
        NotificationManager.warning("Active reason cannot be deleted");
      } else {
        NotificationManager.warning("You need to select a reason");
      }
    }
  };

  let deleteReasonDetail = () => {
    let newState = `${"DELETED"}`;

    if (newDetailsActived[0]) {
      changeStateReasonDetail({
        variables: {
          idReasonDetail: parseInt(newDetailsActived[0]),
          newState: newState,
          userChangeState: getStateLogin(),
        },
      })
        .then((response) => {
          let err = response.data.changeStateReasonsDetail.withError;
          if (err) {
            throw response.data.changeStateReasonsDetail;
          }
          let dto = newDetailsActived;
          dto.splice(0, 1);
          setNewReasonsActived(dto);
          NotificationManager.success(
            "The reason detail of mood meter config has been deleted",
            "",
            5000
          );
          setrenderAgain(!renderAgain);
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else {
      if (detailsActived[0]) {
        NotificationManager.warning("Active detail cannot be deleted");
      } else {
        NotificationManager.warning("You need to select a detail reason");
      }
    }
  };

  let changeStateReasonForward = () => {
    let newState = `${"ACTIVE"}`;

    changeStateReason({
      variables: {
        idReason: parseInt(newReasonsActived[0]),
        newState: newState,
        userChangeState: getStateLogin(),
      },
    })
      .then((response) => {
        let err = response.withError;
        if (!err) {
          NotificationManager.success(
            "The state reason of mood meter config has been updated",
            "",
            5000
          );
          setrenderAgain(!renderAgain);
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  let changeStateReasonBack = () => {
    if (reasons.length > 1) {
      let newState = `${"INACTIVE"}`;
      changeStateReason({
        variables: {
          idReason: parseInt(reasonsActived[0]),
          newState: newState,
          userChangeState: getStateLogin(),
        },
      })
        .then((response) => {
          let err = response.withError;
          if (!err) {
            NotificationManager.success(
              "The state reason of mood meter config has been updated",
              "",
              5000
            );
            setrenderAgain(!renderAgain);
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else {
      NotificationManager.warning(
        "There should be atleast one active reason",
        "",
        5000
      );
    }
  };

  let changeStateDetailForward = () => {
    let newState = `${"ACTIVE"}`;

    changeStateReasonDetail({
      variables: {
        idReasonDetail: parseInt(newDetailsActived[0]),
        newState: newState,
        userChangeState: getStateLogin(),
      },
    })
      .then((response) => {
        let err = response.withError;
        if (!err) {
          NotificationManager.success(
            "The state reason detail of mood meter config has been updated",
            "",
            5000
          );
          setrenderAgain(!renderAgain);
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  let changeStateDetailBack = () => {
    if (details.length > 1) {
      let newState = `${"INACTIVE"}`;

      changeStateReasonDetail({
        variables: {
          idReasonDetail: parseInt(detailsActived[0]),
          newState: newState,
          userChangeState: getStateLogin(),
        },
      })
        .then((response) => {
          let err = response.withError;
          if (!err) {
            NotificationManager.success(
              "The state reason detail of mood meter config has been updated",
              "",
              5000
            );
            setrenderAgain(!renderAgain);
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else {
      NotificationManager.warning(
        "There should be atleast one active detail",
        "",
        5000
      );
    }
  };

  const goBack = () => {
    history.push({
      pathname: "/Home",
    });
  };

  useEffect(() => {
    runQueryGetTimeConfig();
    //runQuerySmileys();
  }, []);

  useEffect(() => {
    setSendSmileys(!!smileySelect);
    setSendUsers(!!citySelected);
    setSendReasonDetails(!!newQuestion);
  }, [smileySelect, citySelected, newQuestion]);

  let showAddReasonModal = () => {
    return openReasonModal ? (
      <PortalModal>
        <ContentModalAdd>
          <TextModalAdd>
            <p>Add Reason</p>
          </TextModalAdd>
          <Row>
            <Col md={12}>
              <Form.Control
                placeholder="Type here"
                className="m-3 w-75"
                name="create-reason"
                type="text"
                value={addReason !== "" ? addReason : ""}
                onChange={(e) => {
                  setAddReason(e.currentTarget.value);
                }}
              />
            </Col>
          </Row>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              width: "65%",
            }}
          >
            <ButtonAddCancel onClick={() => setOpenReasonModal(null)}>
              Cancel
            </ButtonAddCancel>
            <ButtonAdd onClick={() => saveReason()}>Ok</ButtonAdd>
          </div>
        </ContentModalAdd>
      </PortalModal>
    ) : null;
  };

  let showAddDetailModal = () => {
    return openDetailModal ? (
      <PortalModal>
        <ContentModalAdd>
          <TextModalAdd>
            <p>Add Detail</p>
          </TextModalAdd>
          <Row>
            <Col md={12}>
              <Form.Control
                placeholder="Type here"
                className="m-3 w-75"
                name="create-detail"
                type="text"
                value={addDetail !== "" ? addDetail : ""}
                onChange={(e) => {
                  setAddDetail(e.currentTarget.value);
                }}
              />
            </Col>
          </Row>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              width: "65%",
            }}
          >
            <ButtonAddCancel onClick={() => setOpenDetailModal(null)}>
              Cancel
            </ButtonAddCancel>
            <ButtonAdd onClick={() => saveDetail()}>Ok</ButtonAdd>
          </div>
        </ContentModalAdd>
      </PortalModal>
    ) : null;
  };

  return (
    <>
      <GeneralContainer>
        <Header>
          <MoodMeterLogo>
            <MoodMeterSettingsIcon />
          </MoodMeterLogo>
          <MoodMeterText>Mood Meter</MoodMeterText>
        </Header>
        <div style={{ marginTop: "1rem" }}>
          <BackButtonComponent
            backtitle={"Mood Meter"}
            locationtitle={"Settings"}
            goToBackPage={goBack}
            identity={"isMoodMeterSettings"}
          />
        </div>
        <hr className="inline-hr" />
        {/* <SmileysContainer>
          <div style={{ marginTop: "1rem", marginLeft: "1rem" }}>
            <p style={{ fontWeight: "700", marginBottom: "0rem" }}>Smileys</p>
            <p style={{ fontWeight: "400", marginBottom: "-1rem" }}>
              Select the emoticons you want agents to see as options
            </p>
          </div>
          <FeelingFaces
            styles={{
              display: "grid",
              gridTemplateColumns: "repeat(14, 70px)",
            }}
            faces={faces}
            hidefaces={false}
            config_smileys={true}
            smileySelect={smileySelect}
            setSmileySelect={setSmileySelect}
            runQuerySmileys={runQuerySmileys}
            isMoodMeterSettings={true}
          ></FeelingFaces>
        </SmileysContainer> */}
        <UsersContainer>
          <div
            style={{
              marginTop: "1rem",
              marginLeft: "1rem",
              marginBottom: "1rem",
            }}
          >
            <p style={{ fontWeight: "700", marginBottom: "0rem" }}>Users</p>
          </div>
          {/* <Row> */}
          <div style={{ display: "flex", zIndex: "4", position: "relative" }}>
            <ContentSelect style={{ width: "50%", margin: "10px 1rem" }}>
              <Form.Label>Country</Form.Label>
              <Select1
                placeholder="Select a country"
                ref={rSelectedCountries}
                options={countriesData}
                styles={SelectStyles}
                onChange={handleChangeSelectCountries}
              />
            </ContentSelect>
            <ContentSelect style={{ width: "50%", margin: "10px 1rem" }}>
              <Form.Label>City</Form.Label>
              <Select1
                placeholder="Select a city"
                ref={rSelectedCity}
                options={cityData}
                styles={SelectStyles}
                onChange={handleChangeSelectCity}
              />
            </ContentSelect>
          </div>
          {/* </Row> */}
          <ContentSelect
            style={{ margin: "10px 1rem", zIndex: "3", position: "relative" }}
            users={true}
          >
            <Row className="align-center">
              <Col md={6}>
                <Form.Label>Select User </Form.Label>
                <Select1
                  placeholder={
                    <>
                      <IconGuest src={guestIcon}></IconGuest>
                      <strong className="select-placeholder">Add guests</strong>
                    </>
                  }
                  isMulti
                  ref={rSelectedUsers}
                  options={guestsData}
                  styles={SelectStyles}
                  onChange={handleChangeSelectUsers}
                />
              </Col>
              <Col
                md={6}
                className="d-flex justify-content-end align-items-center"
              >
                <Form.Label>
                  <Checkbox
                    onChange={(e) => handleCatchAllEvents(e)}
                    icon={<CropLandscapeIcon />}
                  />
                  Catch All
                </Form.Label>
              </Col>
            </Row>
            {((countrySelected && citySelected) || activeCatchAll) &&
              selectedGuests.length > 0 &&
              !loading &&
              !error && (
                <Row>
                  <Col md="6">
                    <List>
                      {selectedGuests &&
                        selectedGuests.map((item, index) => {
                          return (
                            <Row
                              className={
                                "justify-content-center align-items-center margin-0 guest-users-list"
                              }
                              key={index}
                            >
                              <Col md="8">{item.label}</Col>
                              <Col md="4" className="remove-icon">
                                <Tooltip title="Remove">
                                  <IconButton
                                    onClick={() =>
                                      removeUser(index, item.label)
                                    }
                                  >
                                    <DeleteForeverRoundedIcon />
                                  </IconButton>
                                </Tooltip>
                              </Col>
                            </Row>
                          );
                        })}
                    </List>
                  </Col>
                </Row>
              )}
          </ContentSelect>
        </UsersContainer>
        <TimeContainer>
          <div
            style={{
              marginTop: "1rem",
              marginLeft: "1rem",
              marginBottom: "1rem",
            }}
          >
            <p style={{ fontWeight: "700", marginBottom: "0rem" }}>Time</p>
          </div>
          <Row style={{ paddingLeft: "1rem", paddingRight: "1rem" }}>
            <Col md={6}>
              <ContentSelect>
                <Form.Label>Inactivity Interval(In hours)</Form.Label>
                <Row
                  className="align-items-center margin-0"
                  style={{ position: "absolute", width: "44%", zIndex: 2 }}
                >
                  <Select1
                    placeholder="Select an option"
                    ref={rselectedInterval}
                    options={intervalOptions}
                    styles={SelectStyles}
                    className="number-dropdown"
                    isDisabled={true}
                    value={{
                      label: inactivityInterval,
                      value: inactivityInterval,
                    }}
                    onChange={(e) => {
                      setInactiveInterval(parseInt(e.value));
                    }}
                  />
                </Row>
              </ContentSelect>
            </Col>
            <Col md={6}>
              <ContentSelect>
                <Form.Label>Max occurrences per day:</Form.Label>
                <Row
                  className="align-items-center margin-0"
                  style={{ position: "absolute", width: "44%", zIndex: 2 }}
                >
                  <Select1
                    placeholder="Select an option"
                    ref={rselectedOccurrence}
                    options={occurrenceOptions}
                    styles={SelectStyles}
                    isDisabled={true}
                    className="number-dropdown"
                    value={{
                      label: ocurrencesPerDay,
                      value: ocurrencesPerDay,
                    }}
                    onChange={(e) => {
                      setOcurrencesPerDay(parseInt(e.value));
                    }}
                  />
                </Row>
              </ContentSelect>
            </Col>
          </Row>
        </TimeContainer>
        {/* <ReasonDetailContainer>
          <div
            style={{
              marginTop: "1rem",
              marginLeft: "1rem",
              marginBottom: "1rem",
            }}
          >
            <p style={{ fontWeight: "700", marginBottom: "0rem" }}>
              {"Reason & details"}
            </p>
          </div>
          <div style={{ display: "flex", width: "100%", padding: "1rem" }}>
            <div style={{ width: "50%", marginRight: "1rem" }}>
              <Form.Label className="ml-0" style={{ fontWeight: 500 }}>
                Question
              </Form.Label>
              <div className="align-items-center justify-content-center mb-3">
                <div>
                  <TextField
                    id="outlined-multiline-static"
                    label="Type a new question"
                    color="secondary"
                    rows={3}
                    className={"w-100"}
                    defaultValue={timeConfig?.questionForUser}
                    onChange={(e) => handleNewQuestion(e)}
                  />
                </div>
              </div>
              <Form.Label className="ml-0" style={{ fontWeight: 500 }}>
                Reasons
              </Form.Label>
              <div style={{ display: "flex", width: "100%" }}>
                <div style={{ width: "45%" }}>
                  <div>
                    <FormControl
                      sx={{ m: 0, minWidth: 140, maxWidth: 300, width: "100%" }}
                    >
                      <InputLabel shrink htmlFor="select-multiple-native">
                        Inactive
                      </InputLabel>
                      <Select2
                        style={{ height: "7rem" }}
                        multiple
                        native
                        value={newReasonsActived}
                        onChange={handleChangeMultipleNewReasons}
                        label="Native"
                        inputProps={{
                          id: "select-multiple-native",
                        }}
                      >
                        {newReasons.map((newReason) => (
                          <option key={newReason.value} value={newReason.value}>
                            {newReason.label}
                          </option>
                        ))}
                      </Select2>
                    </FormControl>
                  </div>
                  <div style={{ float: "right" }}>
                    <ContentButtons>
                      <ButtonLink
                        style={{ marginRight: "1rem" }}
                        onClick={() => deleteReason()}
                      >
                        Delete
                      </ButtonLink>
                      <ButtonLink
                        onClick={() => {
                          setOpenReasonModal(true);
                        }}
                      >
                        Add
                      </ButtonLink>
                    </ContentButtons>
                  </div>
                </div>
                <IconButton
                  style={{ width: "5%" }}
                  onClick={() => {
                    changeStateReasonBack();
                  }}
                >
                  <ArrowBackIosIcon
                    style={{ fontWeight: "400", fontSize: "13px" }}
                  />
                </IconButton>
                <IconButton
                  style={{ width: "5%" }}
                  onClick={() => {
                    changeStateReasonForward();
                  }}
                >
                  <ArrowForwardIosIcon
                    style={{ fontWeight: "400", fontSize: "13px" }}
                  />
                </IconButton>
                <FormControl
                  sx={{
                    m: 0,
                    marginBottom: 3,
                    minWidth: 140,
                    maxWidth: 300,
                    width: "45%",
                  }}
                >
                  <InputLabel shrink htmlFor="select-multiple-native">
                    Active
                  </InputLabel>
                  <Select2
                    style={{ height: "7rem" }}
                    multiple
                    native
                    value={reasonsActived}
                    onChange={handleChangeMultipleReasons}
                    label="Native"
                    inputProps={{
                      id: "select-multiple-native",
                    }}
                  >
                    {reasons.map((reason) => (
                      <option key={reason.value} value={reason.value}>
                        {reason.label}
                      </option>
                    ))}
                  </Select2>
                </FormControl>
              </div>
            </div>
            <div style={{ width: "50%", marginLeft: "1rem" }}>
              <Form.Label className="ml-0" style={{ fontWeight: 500 }}>
                Details
              </Form.Label>
              <div
                className="align-items-center mr-2 mb-3"
                style={{ zIndex: 1, position: "relative" }}
              >
                <Select1
                  placeholder="Select Reason"
                  ref={rSelectedReason}
                  options={reasons}
                  styles={SelectStyles}
                  onChange={handleChangeSelectReason}
                />
              </div>
              <Form.Label
                className="ml-0"
                style={{ fontWeight: 500, marginTop: "1rem" }}
              >
                Reasons
              </Form.Label>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  zIndex: 0,
                  position: "relative",
                }}
              >
                <div style={{ width: "45%" }}>
                  <div>
                    <FormControl
                      sx={{ m: 0, minWidth: 140, maxWidth: 300, width: "100%" }}
                    >
                      <InputLabel shrink htmlFor="select-multiple-native">
                        Inactive
                      </InputLabel>
                      <Select2
                        style={{ height: "7rem" }}
                        multiple
                        native
                        value={newDetailsActived}
                        onChange={handleChangeMultipleNewDetails}
                        label="Native"
                        inputProps={{
                          id: "select-multiple-native",
                        }}
                      >
                        {newDetails.map((newDetail) => (
                          <option key={newDetail.id} value={newDetail.id}>
                            {newDetail.description}
                          </option>
                        ))}
                      </Select2>
                    </FormControl>
                  </div>
                  <div style={{ float: "right" }}>
                    <ContentButtons>
                      <ButtonLink
                        style={{ marginRight: "1rem" }}
                        onClick={() => deleteReasonDetail()}
                      >
                        Delete
                      </ButtonLink>
                      <ButtonLink
                        onClick={() => {
                          if (reasonSelectedForDetail) {
                            setOpenDetailModal(true);
                          } else {
                            NotificationManager.warning(
                              "You need to select a reason, before create a new reason detail"
                            );
                          }
                        }}
                      >
                        Add
                      </ButtonLink>
                    </ContentButtons>
                  </div>
                </div>
                <IconButton
                  style={{ width: "5%" }}
                  onClick={() => changeStateDetailBack()}
                >
                  <ArrowBackIosIcon
                    style={{ fontWeight: "400", fontSize: "13px" }}
                  />
                </IconButton>
                <IconButton
                  style={{ width: "5%" }}
                  onClick={() => changeStateDetailForward()}
                >
                  <ArrowForwardIosIcon
                    style={{ fontWeight: "400", fontSize: "13px" }}
                  />
                </IconButton>
                <FormControl
                  sx={{
                    m: 0,
                    marginBottom: 3,
                    minWidth: 140,
                    maxWidth: 300,
                    width: "45%",
                  }}
                >
                  <InputLabel shrink htmlFor="select-multiple-native">
                    Active
                  </InputLabel>
                  <Select2
                    style={{ height: "7rem" }}
                    multiple
                    native
                    value={detailsActived}
                    onChange={handleChangeMultipleDetails}
                    label="Native"
                    inputProps={{
                      id: "select-multiple-native",
                    }}
                  >
                    {details.map((detail) => (
                      <option key={detail.id} value={detail.id}>
                        {detail.description}
                      </option>
                    ))}
                  </Select2>
                </FormControl>
              </div>
            </div>
          </div>
                    </ReasonDetailContainer>*/}
        <ButtonsContainer>
          <CancelSettings
            style={{ width: "15em" }}
            className="mx-3 mt-2 mb-3"
            onClick={() => goBack()}
          >
            Cancel
          </CancelSettings>
          <SendSettings
            style={{ width: "15em" }}
            className="mx-3 mt-2 mb-3"
            ready={true}
            disabled={false}
            onClick={() => {
              if (sendUsers || activeCatchAll) {
                saveUsers();
              }
              /*
              if (sendSmileys) {
                saveSmileysConfig();
              }
              saveTime();
              if (sendReasonDetails) {
                saveQuestion();
              }*/
            }}
          >
            Save Changes
          </SendSettings>
        </ButtonsContainer>
      </GeneralContainer>
      {showAddReasonModal()}
      {showAddDetailModal()}
      {loadingSmileys && <ModalLoader />}
    </>
  );
};

export default MoodMeterSettings;
